import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Link } from '@material-ui/core';
import SVG from 'react-inlinesvg';
// import { Location, HandsFree } from 'ipapps-corejs';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import images from '../../themes/assets';

export class NotificationIcons extends React.PureComponent {
  /**
   * @name react lifecycle method render
   */
  render() {
    const {
      classes: { itemActions },
      notification,
    } = this.props;

    return (
      <div className={itemActions}>
        {notification.phone_number && this.renderPhone()}
        {notification.lat !== '' && notification.lon !== '' && this.renderNavi()}
      </div>
    );
  }

  /**
   * @renderPhone
   * @description Renders Phone Icon
   */
  renderPhone = () => {
    const {
      notification,
      classes: { phoneIcon, iconDiv },
    } = this.props;
    const styleIcon = code =>
      code.replace(/width=".*?"/g, 'width="3em"').replace(/height=".*?"/g, 'height="3em"');

    // const handsFree = new HandsFree();
    const phoneCall = `tel:${notification.phone_number.replace('+', '')}`; // handsFree.call(notification.phone_number.replace('+', ''));
    return (
      <div className={iconDiv}>
        <Link href={phoneCall} className={phoneIcon}>
          {/* <PhoneOutlined /> */}
          {/* <img
            src={images.PhoneGreenIcon}

            alt={`call ${notification.phone_number}`}
          /> */}
          <SVG
            description="call"
            title="Navi"
            preProcessor={styleIcon}
            uniqueHash="a2f8d2"
            uniquifyIDs
            src={images.PhoneGreenIcon}
          />
        </Link>
      </div>
    );
  };

  /**
   * @name renderNavi
   * @description renders Navi Icon
   */
  renderNavi = () => {
    const location = {
      latitude: '',
      longitude: '',
    }; // new Location();
    const {
      notification,
      classes: { naviIcon, iconDiv },
    } = this.props;
    location.latitude = '#'; // notification.lat;
    location.longitude = notification.lon;
    const styleIcon = code =>
      code.replace(/width=".*?"/g, 'width="3em"').replace(/height=".*?"/g, 'height="3em"');
    return (
      <div className={iconDiv}>
        {/* <Link href={location.scheme.scheme}> */}
        <Link href={location.latitude} className={naviIcon}>
          {/* <img
            src={images.NaviBlueIcon}

            alt={`navi: ${notification.lat} - ${notification.lon}`}
          /> */}

          <SVG
            description="navi"
            preProcessor={styleIcon}
            title="Navi"
            uniqueHash="a1f8d1"
            uniquifyIDs
            src={images.NaviBlueIcon}
          />
        </Link>
      </div>
    );
  };
}

NotificationIcons.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  notification: PropTypes.any.isRequired,
};

export default withStyles(styles)(withTranslation()(NotificationIcons));
